import { useState, useEffect } from 'react';
import { serviceAPI, IMAGE_BASE } from '../../services/api';

export default function ServicesAdmin() {
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [editItem, setEditItem] = useState(null);
    const [form, setForm] = useState({
        title: '', slug: '', shortDescription: '', content: '', icon: '',
        isActive: true, sortOrder: 0, seoTitle: '', seoDescription: '', seoKeywords: ''
    });
    const [imageFile, setImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [formBusy, setFormBusy] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await serviceAPI.getAll();
            setServices(res.data?.data || res.data || []);
        } catch (e) { console.error(e); }
        setLoading(false);
    };

    useEffect(() => { fetchData(); }, []);

    const slugify = (str) => str.toLowerCase().replace(/[ğ]/g,'g').replace(/[ü]/g,'u').replace(/[ş]/g,'s').replace(/[ı]/g,'i').replace(/[ö]/g,'o').replace(/[ç]/g,'c').replace(/[^a-z0-9]+/g,'-').replace(/(^-|-$)/g,'');

    const openCreate = () => {
        setEditItem(null);
        setForm({ title: '', slug: '', shortDescription: '', content: '', icon: '', isActive: true, sortOrder: 0, seoTitle: '', seoDescription: '', seoKeywords: '' });
        setImageFile(null);
        setImagePreview(null);
        setShowModal(true);
    };

    const openEdit = (item) => {
        setEditItem(item);
        setForm({
            title: item.title || '', slug: item.slug || '', shortDescription: item.shortDescription || '',
            content: item.content || '', icon: item.icon || '', isActive: item.isActive,
            sortOrder: item.sortOrder || 0, seoTitle: item.seoTitle || '',
            seoDescription: item.seoDescription || '', seoKeywords: item.seoKeywords || ''
        });
        setImageFile(null);
        setImagePreview(item.image ? IMAGE_BASE + item.image : null);
        setShowModal(true);
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) { setImageFile(file); setImagePreview(URL.createObjectURL(file)); }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormBusy(true);
        try {
            const fd = new FormData();
            Object.entries(form).forEach(([k, v]) => fd.append(k, v));
            if (imageFile) fd.append('image', imageFile);
            if (editItem) {
                await serviceAPI.update(editItem.id, fd);
            } else {
                await serviceAPI.create(fd);
            }
            setShowModal(false);
            fetchData();
        } catch (err) {
            alert(err.response?.data?.error || 'Hata oluştu');
        }
        setFormBusy(false);
    };

    const handleDelete = async (id) => {
        if (!confirm('Bu hizmeti silmek istediğinize emin misiniz?')) return;
        try { await serviceAPI.delete(id); fetchData(); } catch (err) { alert('Silinemedi'); }
    };

    return (
        <div>
            <div className="admin-header">
                <h1>Hizmet / Servis Yönetimi</h1>
                <button className="btn btn-primary" onClick={openCreate}>+ Yeni Hizmet</button>
            </div>

            {loading ? <div className="loading"><div className="spinner"></div></div> : (
                <div className="data-table-wrapper">
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>Görsel</th>
                                <th>Başlık</th>
                                <th>Kısa Açıklama</th>
                                <th>Sıra</th>
                                <th>Durum</th>
                                <th>İşlemler</th>
                            </tr>
                        </thead>
                        <tbody>
                            {services.map(item => (
                                <tr key={item.id}>
                                    <td>
                                        {item.image ? (
                                            <img src={IMAGE_BASE + item.image} alt={item.title} style={{ width: 80, height: 50, objectFit: 'cover', borderRadius: 6 }} />
                                        ) : <span style={{ color: 'var(--text-muted)' }}>{item.icon || '-'}</span>}
                                    </td>
                                    <td style={{ fontWeight: 600 }}>{item.title}</td>
                                    <td style={{ color: 'var(--text-muted)', fontSize: '0.85rem', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {item.shortDescription || '-'}
                                    </td>
                                    <td>{item.sortOrder}</td>
                                    <td>
                                        <span className={`stock-badge ${item.isActive ? 'stock-in' : 'stock-out'}`}>
                                            {item.isActive ? 'Aktif' : 'Pasif'}
                                        </span>
                                    </td>
                                    <td>
                                        <div style={{ display: 'flex', gap: '0.5rem' }}>
                                            <button className="btn-icon" onClick={() => openEdit(item)}>✏️</button>
                                            <button className="btn-icon" onClick={() => handleDelete(item.id)} style={{ color: 'var(--danger)' }}>🗑️</button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            {services.length === 0 && (
                                <tr><td colSpan="6" style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-muted)' }}>Henüz hizmet eklenmemiş</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}

            {showModal && (
                <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && setShowModal(false)}>
                    <div className="modal" style={{ maxWidth: 700 }}>
                        <div className="modal-header">
                            <h2>{editItem ? 'Hizmet Düzenle' : 'Yeni Hizmet'}</h2>
                            <button className="modal-close" onClick={() => setShowModal(false)}>×</button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                                <div className="form-group">
                                    <label>Başlık *</label>
                                    <input className="form-control" value={form.title} onChange={e => setForm({ ...form, title: e.target.value, slug: editItem ? form.slug : slugify(e.target.value) })} required />
                                </div>
                                <div className="form-group">
                                    <label>URL Slug</label>
                                    <input className="form-control" value={form.slug} onChange={e => setForm({ ...form, slug: e.target.value })} />
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                                    <div className="form-group">
                                        <label>İkon (CSS class veya emoji)</label>
                                        <input className="form-control" value={form.icon} onChange={e => setForm({ ...form, icon: e.target.value })} placeholder="ör: fas fa-cog" />
                                    </div>
                                    <div className="form-group">
                                        <label>Görsel</label>
                                        <input type="file" accept="image/*" onChange={handleImageChange} className="form-control" />
                                    </div>
                                </div>
                                {imagePreview && <img src={imagePreview} alt="Preview" style={{ width: '100%', height: 150, objectFit: 'cover', borderRadius: 8, marginBottom: '1rem' }} />}
                                <div className="form-group">
                                    <label>Kısa Açıklama</label>
                                    <textarea className="form-control" rows={2} value={form.shortDescription} onChange={e => setForm({ ...form, shortDescription: e.target.value })} />
                                </div>
                                <div className="form-group">
                                    <label>İçerik (HTML)</label>
                                    <textarea className="form-control" rows={8} value={form.content} onChange={e => setForm({ ...form, content: e.target.value })} />
                                </div>

                                <div style={{ borderTop: '1px solid var(--border)', paddingTop: '1rem', marginTop: '1rem' }}>
                                    <h4 style={{ marginBottom: '0.75rem', fontSize: '0.95rem' }}>SEO Ayarları</h4>
                                    <div className="form-group">
                                        <label>SEO Başlık</label>
                                        <input className="form-control" value={form.seoTitle} onChange={e => setForm({ ...form, seoTitle: e.target.value })} />
                                    </div>
                                    <div className="form-group">
                                        <label>SEO Açıklama</label>
                                        <textarea className="form-control" rows={2} value={form.seoDescription} onChange={e => setForm({ ...form, seoDescription: e.target.value })} />
                                    </div>
                                    <div className="form-group">
                                        <label>SEO Anahtar Kelimeler</label>
                                        <input className="form-control" value={form.seoKeywords} onChange={e => setForm({ ...form, seoKeywords: e.target.value })} placeholder="virgülle ayırın" />
                                    </div>
                                </div>

                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginTop: '1rem' }}>
                                    <div className="form-group">
                                        <label>Sıra</label>
                                        <input type="number" className="form-control" value={form.sortOrder} onChange={e => setForm({ ...form, sortOrder: parseInt(e.target.value) || 0 })} />
                                    </div>
                                    <div className="form-group" style={{ display: 'flex', alignItems: 'flex-end' }}>
                                        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                                            <input type="checkbox" checked={form.isActive} onChange={e => setForm({ ...form, isActive: e.target.checked })} /> Aktif
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>İptal</button>
                                <button type="submit" className="btn btn-primary" disabled={formBusy}>
                                    {formBusy ? 'Kaydediliyor...' : (editItem ? 'Güncelle' : 'Ekle')}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
